import {
  Button,
  CircularProgress,
  withStyles,
  WithStyles
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { stepForward } from '../../../actions/apartments'
import { NextStep } from '../../../actions/types'
import { allDefined, allValid } from '../../../utils/validation/general'

const styles = () => ({
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  skipBtn: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: 'none'
    }
  }
})

interface NextStepButtonProps extends WithStyles, WithTranslation {
  doNextStep: NextStep
  submit: boolean
  customLabel?: string
  disabled?: boolean
  id?: string
  setIsEmpty?: any
  toValidate?: any
  toCheck?: any
  secondary?: boolean
  customClickHandler?: any,
  externalIsLoading?: boolean
}

const SubmitButton = ({
  classes,
  t,
  doNextStep,
  customLabel,
  id,
  submit,
  disabled,
  setIsEmpty,
  toValidate,
  toCheck,
  secondary,
  customClickHandler,
  externalIsLoading
}: NextStepButtonProps) => {
  const [type, setType] = useState('button')
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    // If externalIsLoading changes to false, set isLoading to false
    if (externalIsLoading === false) {
      setIsLoading(false);
    }
  }, [externalIsLoading]);
  useEffect(() => {
    submit ? setType('submit') : setType('button')
  }, [submit])
  const customProps: any = {}

  const handleClick = (arg: any, fields: any) => {
    if (allDefined(arg) && allValid(fields)) {
      setIsEmpty(false)
      setIsLoading(true)
    } else setIsEmpty(true)
  }
  return (
    <Button
      fullWidth
      type={type}
      id={id}
      variant='contained'
      color='primary'
      className={secondary ? classes.skipBtn : classes.primaryBtn}
      onClick={
        () => {
          if (customClickHandler) {
            setIsLoading(true)
            customClickHandler()
          } else if (setIsEmpty && (toValidate || toCheck)) {
            handleClick(toValidate, toCheck)
          }
        }
      }
      style={
        {
          display: submit ? 'flex' : 'none',
          height: '42px',
          alignItems: 'center',
          position: 'relative'
        }
      }
      disabled={disabled}
      {...customProps}
    >
      {isLoading ? (
        <CircularProgress
          size={25}
          style={{ color: secondary ? '#94004A' : '#fff', marginLeft: '5px' }}
        />
      ) : (
        <>
          {customLabel == undefined
            ? t('apartment.actions.submit')
            : typeof customLabel == 'string'
              ? t(`${customLabel}`)
              : customLabel}
        </>
      )}
    </Button>
  )
}
const mapDispatchToProps = (dispatch: Dispatch) => ({
  doNextStep: () => dispatch(stepForward())
})

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(SubmitButton))) as any
